export enum GroupName {
	BENEFICIARIO = 'beneficiario',
	OPERADOR = 'operador',
}
